/**
 * US phone numbers as 3-3-4 ("512-555-0147"), for the renewal flow's phone
 * fields. Accepts whatever is typed or pasted ("(512) 555 0147",
 * "+1 512 555 0147"), keeps digits only, drops a leading country code 1, and
 * never goes past 10 digits.
 */
export const PHONE_MAX_LENGTH = 12 // "512-555-0147"

export const phoneDigits = (value) => {
    // US area codes never start with 0 or 1, so leading 1s (a typed "+1" or
    // "1-") are the country code: dropped as they are typed, not just on paste.
    const digits = String(value === null || value === undefined ? '' : value).replace(/\D/g, '').replace(/^[01]+/, '')
    return digits.slice(0, 10)
}

export const formatPhone334 = (value) => {
    const d = phoneDigits(value)
    if (d.length <= 3) return d
    if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`
    return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`
}
